







import loadable from '../../mixins/loadable/loadable';
import colorable from '../../mixins/colorable/colorable';
import mixins from '../../mixins';

export default mixins(loadable, colorable).extend({
  mixins: [loadable, colorable],
  props: {
    value: { default: 0, type: Number },
    bufferValue: { default: undefined, type: Number },
    height: { default: 2, type: [Number, String] },
    color: { default: 'base', type: String },
    indeterminate: { default: false, type: Boolean },
    bufferColor: { default: undefined, type: String },
  },
  computed: {
    classList() {
      return {
        'p-progress-linear': true,
        indeterminate: this.indeterminate,
      };
    },
    barClassList() {
      const color = this.getAllColors()!;
      return {
        bar: true,
        ...color.class,
      };
    },
    barBufferClassList() {
      return {
        'bar-buffer': true,
        [`color-${this.bufferColor ?? this.color}`]: (this.bufferColor ?? this.color) !== undefined,
      };
    },
    styleList() {
      return {
        height: `${this.height}px`,
      };
    },
    barStyleList() {
      const color = this.getAllColors()!;
      return {
        width: `${Math.min(this.value, 100) ?? 100}%`,
        ...color.style,
      };
    },
    barBufferStyleList() {
      return {
        width: `${Math.min(this.bufferValue, 100) ?? 100}%`,
      };
    },
  },
});
